import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import "./FilterAgencySearch.scss";
import { PropertyApi } from "../../../../../utils/api/Property";
import { getAgencyId, getImageUrl } from "../../../../../utils/helpers/common";
import SearchIcon from "../../../../../components/icons/SearchIcon";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";
import CloseIcon from "../../../../../components/icons/CloseIcon";

const FilterAgencySearch = ({ formik }: { formik: any }) => {
  const [state, setState] = useState({
    agencyListBox: false,
    agencyList: [],
    isLoading: true,
  });

  const onToggelBox = () => {
    setState({
      ...state,
      agencyListBox: !state?.agencyListBox,
    });
  };

  const onClickSelect = (id: string) => {
    if (formik?.values?.selectedAgencyIds?.length) {
      formik.setFieldValue("selectedAgencyIds", [
        ...formik?.values?.selectedAgencyIds,
        id,
      ]);
      setState({
        ...state,
        agencyListBox: !state?.agencyListBox,
      });
    } else {
      formik.setFieldValue("selectedAgencyIds", [id]);
      setState({
        ...state,
        agencyListBox: !state?.agencyListBox,
      });
    }
  };

  const onClickRemove = (id: string) => {
    const result = formik?.values?.selectedAgencyIds.filter(
      (_id: string) => _id !== id
    );

    formik.setFieldValue("selectedAgencyIds", result);
  };

  const getDataApi = async () => {
    setState({
      ...state,
      isLoading: true,
    });
    let res = await PropertyApi.getAgency();

    if (res?.data?.success) {
      const filterResult = res?.data?.data?.docs.filter(
        (data: any) => data?.id !== getAgencyId()
      );
      setState({
        ...state,
        isLoading: false,
        agencyList: filterResult,
      });
    } else {
      setState({
        ...state,
        isLoading: false,
      });
      toast.error(res?.data?.message);
    }
  };

  const agentCheck = (id: string) => {
    return formik?.values?.selectedAgencyIds?.includes(id);
  };

  useEffect(() => {
    getDataApi();
  }, []);

  return (
    <div className="agent-contain-container">
      <div className="agent-heading">
        <p>Agency</p>
      </div>

      <div className="filter-search-agent">
        <div className="filter-search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder="Search Or Select Agency"
          className="filter-search-input"
          onFocus={onToggelBox}
        />
        <div
          className={`filter-down-arrow-icon ${
            state?.agencyListBox ? "open-box" : ""
          }`}
          onClick={onToggelBox}
        >
          {state?.isLoading ? (
            <CircularProgress
              style={{
                width: 20,
                height: 20,
                color: "black",
                marginTop: "-2px",
              }}
            />
          ) : (
            <DownArrowIcon />
          )}
        </div>
      </div>
      <div className="selected-agent-contain">
        {state?.agencyList?.map((data: any) => {
          if (agentCheck(data?._id)) {
            return (
              <div className={`selected-agent`} key={data?._id}>
                <div className="selected-agent-profile-details">
                  <div className="selected-agent-profile-img">
                    <img
                      src={getImageUrl(
                        data?.profile_image_ref?.compressed_file_path
                      )}
                      alt=""
                    />
                  </div>

                  <p className="selected-agent-profile-name">{`${data?.agency_trading_name}`}</p>
                </div>
                <div
                  className="selected-agent-remove-icon"
                  onClick={() => onClickRemove(data?._id)}
                >
                  <CloseIcon />
                </div>
              </div>
            );
          }
        })}
      </div>

      <div
        className={`agent-list-container ${
          state?.agencyListBox ? "" : "display-none"
        }`}
      >
        {state?.agencyList?.length ? (
          state?.agencyList?.map((data: any) => (
            <div
              className={`agent-list-item ${
                agentCheck(data?._id) ? "agent-list-item-active" : ""
              }`}
              key={data?._id}
              onClick={() => onClickSelect(data?._id)}
            >
              <div className="item-profile-img">
                <img
                  src={getImageUrl(
                    data?.profile_image_ref?.compressed_file_path
                  )}
                  alt=""
                />
              </div>
              <p className="item-profile-name">{`${data?.agency_trading_name}`}</p>
            </div>
          ))
        ) : (
          <div className="agent-list-not-found">
            <p>Agents not found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterAgencySearch;
